import { render, staticRenderFns } from "./AdminSwatVersionForm.vue?vue&type=template&id=a1b784d0&"
import script from "./AdminSwatVersionForm.vue?vue&type=script&lang=js&"
export * from "./AdminSwatVersionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports